import { TranscricaoStepEnum } from './types';

export const transcricaoSteps = [
  { value: TranscricaoStepEnum.Anexos, label: 'Anexos' },
  { value: TranscricaoStepEnum.Transcricao, label: 'Revisão do pedido' },
];
